module.exports = __webpack_public_path__ + "media/images/static/top/urban/hero_jp-99c33e8360010f75b822b74f87a1043d.png";